import React from 'react';
import { IAuthorizationContext } from './IAuthorizationContext';

export const AuthorizationContext = React.createContext<IAuthorizationContext>(
    {} as IAuthorizationContext
);
